// extracted by mini-css-extract-plugin
module.exports = {" _key":"@dojo/widgets/menu-item","root":"menu-item-m__root__1LkPf","active":"menu-item-m__active__3K8Hl","disabled":"menu-item-m__disabled__20doE"};